import React from "react"
import styled from "styled-components"
import { Card } from "../../atoms"
import parse from "html-react-parser"
import useDeviceTheme from "@project/shared/src/useDeviceTheme"

export interface IOrganizationCard {
  icon: React.ReactNode
  lightIcon: React.ReactNode
  title: string
  content: string
}
const IconStyle = styled.div`
  img {
    height: 50px;
    width: 50px;
    @media (max-width: 1023px) {
      height: 40px;
      width: 40px;
    }
  }
`
const CardWrapper = styled(Card)`
  padding: 40px 30px;
  min-height: 285px;
  cursor: pointer;
  width: 100%;
  border-radius: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: ${(props) => props.theme.base};
  background-color: ${(props) => props.theme.midnightNavy};
  @media (max-width: 1023px) {
    padding: 32px 20px;
    border-radius: 20px;
  }
  @media (max-width: 600px) {
    min-height: 215px;
  }
  &:hover {
    background-color: ${(props) => props.theme.hoverColor};
  }
`
const TextStyle = styled.div`
  ${(props) => props.theme.typography.paragraph2}
  font-size: 14px;
  font-weight: 400;
  line-height: 170%;
  margin-top: 8px;
  text-align: center;
  white-space: break-spaces;
  color: ${(props) => props.theme.sneakPeakTextColor};
  @media (max-width: 1100px) {
    white-space: normal;
  }
`
const TitleStyle = styled.div`
  ${(props) => props.theme.typography.cardTitle}
  font-size: 18px;
  font-weight: 600;
  line-height: 170%;
  margin-top: 20px;
  text-align: center;
  white-space: break-spaces;
  color: ${(props) => props.theme.sneakPeakTitleColor};
  @media (max-width: 1023px) {
    font-size: 1rem;
  }
`
export const OrganizationCard: React.FC<IOrganizationCard> = ({
  lightIcon,
  icon,
  content,
  title,
}) => {
  const iseDeviceTheme = useDeviceTheme()
  return (
    <CardWrapper
    // gradientBorder={true}
    // borderRadius={"50px"}
    // gradientBorderTop={"1px"}
    >
      <IconStyle>{iseDeviceTheme ? icon : lightIcon}</IconStyle>
      <TitleStyle>{title}</TitleStyle>
      <TextStyle>{parse(content)}</TextStyle>
    </CardWrapper>
  )
}
